__webpack_require__.p = "https://assets-01.periodica.press/be232e5-23198796756/";